import { render, staticRenderFns } from "./studentreceipt.vue?vue&type=template&id=101facc6"
import script from "./studentreceipt.vue?vue&type=script&lang=js"
export * from "./studentreceipt.vue?vue&type=script&lang=js"
import style0 from "./studentreceipt.vue?vue&type=style&index=0&id=101facc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports